export default __webpack_public_path__ + "static/media/interest-con.30710719.svg";